import React, {Component} from 'react';
import axios from 'axios';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {saveGeneralUserSubscriber, unSubscriberbyGeneralUser} from '../../api';
import Options from './options';
import Expire from '../expire';
import initGlobe from './initGlobe';
import {b64EncodeUnicode} from '../../utils/utils';

@withRouter
@connect(
    state => state.page,
    null
)
class SubscribePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: this.props.match.params.email,
            expire: false,
            // admin subscription
            name: '',
            emailAddress: '',
            companyName: '',
            pageStyle: {
                fontFamily: '',
                subBtnFontColor: '',
                unSubBtnFontColor: '',
                headlineColor: '',
                subBtnBgColor: '',
                unSubBtnBgColor: ''
            }
        };
    }
    
    componentDidMount() {
        this._initGlobe();
        let {email} = this.state;
        if (!this.props.manage) {
            if (this.props.location.pathname.indexOf("subscriptionemail") > 0) {
                axios.get(`/api/subscribe/subscriptionemail/${email}`, {headers: {'tenantname': this.props.name}})
                .then(res => {
                    let data = res.data || {};
                    if (res.status === "success" && data.subscribFlag === "Subscribed") {
                        this._initData(data);
                    }
                })
                .catch(err => {
                    this.props.history.push(`/subscribe/subscriptionemail/${email}/error`);
                    console.log(err);
                });
            } else {
                axios.get(`/api/subscribe/subscriptionNew/${email}/regist`, {headers: {'tenantname': this.props.name}})
                .then(res => {
                    let data = res.data || {};
                    if (res.status === "success" && data.subscribFlag === "Subscribed") {
                        this._initData(data);
                    } else if (res.status === "error") {
                        this.setState({expire: true});
                    }else{
                        //default init
                        $(".English").attr("checked", true);
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.setState({expire: true});
                });
            }
        } else {
            let {id} = this.props.match.params;
            axios.get(`/api/subscribe/subscription/${id}`, {headers: {'token': sessionStorage.getItem("token")}})
            .then(res => {
                let data = res.data || {};
                if (data.clientId) $("#clientId").val(data.clientId);
                if (res.status === "success" && data.subscribFlag === "Subscribed") {
                    this._initData(data);
                }
                this.setState({
                    email: b64EncodeUnicode(data.email),
                    name: data.tenantName,
                    emailAddress: data.email,
                    companyName: data.companyName,
                    pageStyle: {
                        fontFamily: data.fontFamily,
                        subBtnFontColor: data.subBtnFontColor,
                        unSubBtnFontColor: data.unSubBtnFontColor,
                        headlineColor: data.headlineColor,
                        subBtnBgColor: data.subBtnBgColor,
                        unSubBtnBgColor: data.unSubBtnBgColor
                    }
                });
            })
            .catch(err => {
                console.log(err);
            });
        }
    }
    
    _initGlobe = () => {
        // if (this.props.manage) $('.right-panel').css("margin-top", "-150px");
        let arrayEl = $(".countrys option");
        initGlobe(arrayEl);
    };
    
    _initData = data => {
        // init emailFormat
        if (data.emailFormat === 'html') $(".html").attr("checked", true);
        else if (data.emailFormat === 'text') $(".text").attr("checked", true);
        // init emailLanguage
        if(data.emailLanguage && Array.isArray(data.emailLanguage)){
            data.emailLanguage.forEach(language => {
                if(language === 'English') $(".English").attr("checked", true);
                else if (language === 'French') $(".French").attr("checked", true);
                else if (language === 'Spanish') $(".Spanish").attr("checked", true);
            });
        }
        // init daily
        if (data.dailySummary) $("#daily").attr("checked", true);
        else $("#daily").attr("checked", false);
        // init user data
        let medicalCountryArray = [];
        let specialAdvisoryCountryArray = [];
        let travelAlertCountryArray = [];
        if (data.clientId) $("#clientId").val(data.clientId);
        if (data.medicalAlerts && data.medicalAlerts.length > 0) {
            // medicalCountryArray = data.medicalAlerts[0].countries;
            data.medicalAlerts.forEach(d => {
                if (d.subType === "nTag") {
                    if (d.countries && d.countries.length > 0 && d.countries.some(v => v !== "")) {
                        medicalCountryArray = d.countries;
                        $("#mn").attr("checked", true);
                    }
                }
                if (d.subType === "aTag") {
                    if (d.countries && d.countries.length > 0 && d.countries.some(v => v !== "")) {
                        medicalCountryArray = d.countries;
                        $("#ma").attr("checked", true);
                    }
                }
                if (d.subType === "saTag") {
                    if (d.countries && d.countries.length > 0 && d.countries.some(v => v !== "")) {
                        medicalCountryArray = d.countries;
                        $("#msa").attr("checked", true);
                    }
                }
            });
        }
        if (data.travels && data.travels.length > 0) {
            data.travels.forEach(d => {
                if (d.subType === "nTag") {
                    if (d.countries && d.countries.length > 0 && d.countries.some(v => v !== "")) {
                        specialAdvisoryCountryArray = d.countries;
                        $("#tn").attr("checked", true);
                    }
                }
                if (d.subType === "aTag") {
                    if (d.countries && d.countries.length > 0 && d.countries.some(v => v !== "")) {
                        specialAdvisoryCountryArray = d.countries;
                        $("#ta").attr("checked", true);
                    }
                }
                if (d.subType === "saTag") {
                    if (d.countries && d.countries.length > 0 && d.countries.some(v => v !== "")) {
                        travelAlertCountryArray = d.countries;
                        $("#tsa").attr("checked", true);
                    }
                }
                if (d.subType === "enTag") {
                    if (d.countries && d.countries.length > 0 && d.countries.some(v => v !== "")) {
                        travelAlertCountryArray = d.countries;
                        $("#ten").attr("checked", true);
                    }
                }
            });
        }
        let initData = [
            {dataArr: medicalCountryArray, domEl: "#medical"},
            {dataArr: specialAdvisoryCountryArray, domEl: "#specialAdvisory"},
            {dataArr: travelAlertCountryArray, domEl: "#travelAlert"}
        ];
        $.each(initData, function (i) {
            $.each(initData[i].dataArr, function (j) {
                if (initData[i].dataArr[j] != '') {
                    if (initData[i].dataArr[j] === "All") {
                        $(initData[i].domEl + " .countrysMenu").children().eq(1).find("a").addClass("allCountry");
                        let newTag = $('<span class="tag label label-info">All<span data-role="remove" class="allCountries"></span> </span>');
                        let $tagsinput = $(initData[i].domEl).find(".tagsinput");
                        newTag.insertBefore($tagsinput);
                        return;
                    }
                    
                    let isExist = initData[i].dataArr[j];
                    let listExist = $(initData[i].domEl + " .countrysMenu > li > a");
                    $.each(listExist, function (j) {
                        if (isExist == $(listExist[j]).text()) {
                            if (isExist === "All") {
                                return;
                            }
                            $(listExist[j]).parent().hide();
                        }
                    });
                    let newTag = $('<span class="tag label label-info">' + initData[i].dataArr[j] + '<span data-role="remove"></span> </span>');
                    let $tagsinput = $(initData[i].domEl).find(".tagsinput");
                    newTag.insertBefore($tagsinput);
                }
            });
        });
    };
    
    subscribeHandler = () => {
        let {email} = this.state;
        let tenantname;
        if (this.props.manage) tenantname = this.state.name;
        else tenantname = this.props.name;
        
        let tn = $("#tn");
        let ta = $("#ta");
        let tsa = $("#tsa");
        let ten = $("#ten");
        let mn = $("#mn");
        let ma = $("#ma");
        let msa = $("#msa");
        
        let medicalListEl = $("#medical").find("span.tag");
        let specialAdvisoryListEl = $("#specialAdvisory").find("span.tag");
        let travelAlertEl = $("#travelAlert").find("span.tag");
        let selectedLanguageEl = $("[name = 'emailLanguage']:checked");
        
        let medicalCountry = [];
        let specialAdvisoryCountry = [];
        let travelAlertCountry = [];
        let emailLanguage = [];
        
        $.each(medicalListEl, function (i) {
            let countryStr = $(medicalListEl[i]).text();
            let country = $.trim(countryStr);
            medicalCountry.push(country);
        });
        
        $.each(specialAdvisoryListEl, function (i) {
            let countryStr = $(specialAdvisoryListEl[i]).text();
            let country = $.trim(countryStr);
            specialAdvisoryCountry.push(country);
        });
        
        $.each(travelAlertEl, function (i) {
            let countryStr = $(travelAlertEl[i]).text();
            let country = $.trim(countryStr);
            travelAlertCountry.push(country);
        });
        
        let daily = $("#daily").is(":checked");
        let emailFormat = $("[name = 'emailType']:checked").val();

        $.each(selectedLanguageEl, function (i) {
            emailLanguage.push($(selectedLanguageEl[i]).val());
        });
        let clientId = $("#clientId").val();
        let travel = {nTag: [], aTag: [], saTag: [], enTag: []};
        let medicalalert = {nTag: [], aTag: [], saTag: []};
        if (tn.is(":checked")) travel.nTag = specialAdvisoryCountry;
        if (ta.is(":checked")) travel.aTag = specialAdvisoryCountry;
        if (tsa.is(":checked")) travel.saTag = travelAlertCountry;
        if (ten.is(":checked")) travel.enTag = travelAlertCountry;
        if (mn.is(":checked")) medicalalert.nTag = medicalCountry;
        if (ma.is(":checked")) medicalalert.aTag = medicalCountry;
        if (msa.is(":checked")) medicalalert.saTag = medicalCountry;

        //No Email Languages
        if (emailLanguage.length == 0) {
            $("#noEmailLanguage").modal("show");
            return;
        }

        // no type?
        if (specialAdvisoryCountry.length > 0 && !tn.is(":checked") && !ta.is(":checked")) {
            $("#noType").modal("show");
            return;
        }
        if (travelAlertCountry.length > 0 && !tsa.is(":checked") && !ten.is(":checked")) {
            $("#noType").modal("show");
            return;
        }
        if (medicalCountry.length > 0 && !mn.is(":checked") && !ma.is(":checked") && !msa.is(":checked")) {
            $("#noType").modal("show");
            return;
        }
        
        // no country?
        if (tn.is(":checked") || ta.is(":checked")) {
            if (specialAdvisoryCountry.length === 0) {
                $("#noCountry").modal("show");
                return;
            }
        }
        if (tsa.is(":checked") || ten.is(":checked")) {
            if (travelAlertCountry.length === 0) {
                $("#noCountry").modal("show");
                return;
            }
        }
        if (mn.is(":checked") || ma.is(":checked") || msa.is(":checked")) {
            if (medicalCountry.length === 0) {
                $("#noCountry").modal("show");
                return;
            }
        }
        
        let d = {
            daily: daily,
            emailFormat: emailFormat,
            emailLanguage: emailLanguage,
            email: email,
            travel: travel,
            medicalalert: medicalalert
        };
        if (clientId) d.clientId = clientId;
        saveGeneralUserSubscriber(d, {headers: {'tenantname': tenantname}})
        .then(res => {
            if (res.status === "success") {
                window.onresize();
                $.sound_on = false;
                $.bigBox({
                    title: "Alert",
                    content: "Your preferences have been saved successfully.",
                    color: "#739E73",
                    timeout: 6000,
                    icon: "fa fa-check",
                    number: "Thank you"
                });
            }
        })
        .catch(err => {
            console.log(err);
        });
    };
    
    unSubscribeHandler = () => {
        let {email} = this.state;
        let tenantname;
        if (this.props.manage) tenantname = this.state.name;
        else tenantname = this.props.name;
        unSubscriberbyGeneralUser({email}, {headers: {'tenantname': tenantname}})
        .then(res => {
            if (res.status === "success") {
                // $("#clientId").val("");
                $("#medical").find("span.tag").remove();
                $("#specialAdvisory").find("span.tag").remove();
                $("#travelAlert").find("span.tag").remove();
                if ($("#daily").is(":checked")) $("#daily").attr("checked", false);
                $(".countrysMenu li a").removeClass("allCountry");
                $("#mn").attr("checked", false);
                $("#ma").attr("checked", false);
                $("#msa").attr("checked", false);
                $("#tn").attr("checked", false);
                $("#ta").attr("checked", false);
                $("#tsa").attr("checked", false);
                $("#ten").attr("checked", false);
                window.onresize();
                $.sound_on = false;
                $.bigBox({
                    title: "Alert",
                    content: "Your preferences have been saved successfully.",
                    color: "#739E73",
                    timeout: 6000,
                    icon: "fa fa-check",
                    number: "Thank you"
                });
            }
        })
        .catch(err => {
            console.log(err);
        });
    };
    
    render() {
        let {email, expire, emailAddress} = this.state;
        let fontFamily, subBtnFontColor, unSubBtnFontColor, headlineColor, subBtnBgColor, unSubBtnBgColor, companyName;
        if (this.props.manage) {
            companyName = this.state.companyName;
            fontFamily = this.state.pageStyle.fontFamily;
            subBtnFontColor = this.state.pageStyle.subBtnFontColor;
            unSubBtnFontColor = this.state.pageStyle.unSubBtnFontColor;
            headlineColor = this.state.pageStyle.headlineColor;
            subBtnBgColor = this.state.pageStyle.subBtnBgColor;
            unSubBtnBgColor = this.state.pageStyle.unSubBtnBgColor;
        } else {
            companyName = this.props.companyName;
            fontFamily = this.props.pageStyle.fontFamily;
            subBtnFontColor = this.props.pageStyle.subBtnFontColor;
            unSubBtnFontColor = this.props.pageStyle.unSubBtnFontColor;
            headlineColor = this.props.pageStyle.headlineColor;
            subBtnBgColor = this.props.pageStyle.subBtnBgColor;
            unSubBtnBgColor = this.props.pageStyle.unSubBtnBgColor;
        }
        if (expire) return <Expire email={email}/>;
        return (
            <div id="content" className="container" style={{fontFamily: fontFamily, maxWidth: '100%'}}>
                <div className="row" style={{marginTop: 14}}>
                    <div className="col-md-5 col-md-offset-1">
                        <h1 className="login-header-big"
                            style={{fontSize: 24, color: headlineColor}}>
                            Welcome to <br/>{`${companyName.toUpperCase()} Alert Subscription Management`}
                        </h1>
                        <p>
                            Customize your subscription by selecting the types of alerts you would like to receive. You
                            can select one country, multiple countries of your choice, or all countries.
                        </p>
                        <br/>
                    </div>
                </div>
                <div className="row" style={{marginTop: 14}}>
                    <div className="col-md-5 col-md-offset-1">
                        <div className="">
                            <h4>What are the different types of alerts?</h4>
                            <br/>
                            <ul className="list-unstyled subscript-content" style={{paddingLeft: 40}}>
                                <li>
                                    <p>
                                        <span className="sub-notice"/><strong>Notice:</strong>
                                        &nbsp;Routine planned events or travel disruption issues with no significant
                                        changes to medical or travel risk environment, representing a limited medical
                                        and/or travel security risk to travellers. Examples include: increase in dengue
                                        cases; seasonal flu updates; measles outbreaks; planned protests with limited
                                        risk to bystanders and minor travel disruption; ground transport strike where
                                        travellers may not have suitable alternative options; and air travel disruption
                                        issues.
                                    </p>
                                </li>
                                <br/>
                                <li>
                                    <p>
                                        <span className="sub-advisory"/><strong>Advisory:</strong>
                                        &nbsp;Major developments requiring additional readiness from travellers, events
                                        causing significant travel disruption, or incidents that result in increased
                                        medical/travel security risk. Examples include: a dengue outbreak in a country
                                        where it is not usually present; severe air pollution in an area that does not
                                        usually experience high levels of pollution; a zika outbreak in a previously
                                        unaffected location; protests that pose significant risks to bystanders or cause
                                        major travel disruption; violent crime incidents affecting foreigners; and
                                        security incidents such as bombings or attacks that pose incidental risks to
                                        mobile employees in countries where such incidents occur regularly.
                                    </p>
                                </li>
                                <br/>
                                <li>
                                    <p>
                                        <span className="sub-spe-advisory"/><strong>Special Advisory:</strong>
                                        &nbsp;Significant unexpected development or major issue causing a substantial
                                        change to the medical or travel security risk environment, that necessitate an
                                        immediate response from travellers in the immediate vicinity of the incident,
                                        and from managers who might have staff exposed. Examples include: terrorist
                                        attacks such as bombings in major cities where travellers are present; major
                                        airports closures; transport incidents resulting in many fatalities; major
                                        health risks such as chemical spills or severe epidemics; and major natural
                                        disasters such as earthquakes, cyclones or tsunamis.
                                    </p>
                                </li>
                                <br/>
                                <li>
                                    <p>
                                        <span className="sub-notification"/><strong>Evacuation Notification:</strong>
                                        &nbsp;Substantial developments leading to major changes in the medical or travel
                                        security risk environment that necessitate preparation for evacuation. Examples
                                        of such incidents include: major nuclear incidents; health care systems,
                                        including major hospitals, not able to function; escalating civil conflicts; and
                                        major deteriorations in security following coups attempts.
                                    </p>
                                </li>
                            </ul>
                            <p style={{marginTop: 25}}>
                                <strong>Daily Summary:</strong>
                                &nbsp;One email sent each day, containing every alert published in the last 24 hours
                                about events around the world. The Daily Summary is sent each day at 00:00 Eastern
                                Standard Time and includes all alert types.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-5 right-panel" style={{marginTop: -170}}>
                        <div className="well no-padding">
                            <form className="client-form smart-form ">
                                <header>
                                    {`Edit ${emailAddress ? emailAddress : "your"} subscription`}
                                </header>
                                <div className="widget-body"
                                     style={{background: `#f3f3f3`}}>
                                    <fieldset>
                                        <Options/>
                                        {
                                            this.props.manage &&
                                            <div className="form-group form-group-clientid"
                                                 style={{marginBottom: 35}}>
                                                <legend style={{paddingTop: 0}}>Enter User's Company Name</legend>
                                                <br/>
                                                <input type="text"
                                                       className="form-control clientId"
                                                       id="clientId"
                                                       placeholder="Please enter Company Full Name"/>
                                            </div>
                                        }
                                        <div className="form-group">
                                            <legend style={{paddingTop: 0}}>Daily Summary Alerts</legend>
                                            <label className="checkbox" style={{marginTop: 15, display: 'block'}}>
                                                <input id="daily" type="checkbox"/>
                                                <i/>
                                                Subscribe to Daily Summary Alerts
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <legend>Email Formats</legend>
                                            <label style={{marginTop: 15}}> Which format of emails you want to
                                                receive?</label>
                                            <div id="emailFormat" className="inline-group" data="">
                                                <label className="radio">
                                                    <input type="radio" name="emailType" value="html" className="html"
                                                           defaultChecked={true}/>
                                                    <i/>HTML emails
                                                </label>
                                                <label className="radio">
                                                    <input type="radio" name="emailType" value="text" className="text"/>
                                                    <i/>Plain text emails
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <legend>Email Languages</legend>
                                            <label style={{marginTop: 15}}> In which language do you want to receive
                                                emails?</label>
                                            <div id="emailLanguage" className="inline-group" data="">
                                                <label className="checkbox">
                                                    <input type="checkbox" name="emailLanguage" value="English"
                                                           className="English"/>
                                                    <i/>English
                                                </label>
                                                <label className="checkbox">
                                                    <input type="checkbox" name="emailLanguage" value="French"
                                                           className="French"/>
                                                    <i/>French
                                                </label>
                                                <label className="checkbox">
                                                    <input type="checkbox" name="emailLanguage" value="Spanish"
                                                           className="Spanish"/>
                                                    <i/>Spanish
                                                </label>
                                            </div>
                                        </div>
                                        <h2 style={{paddingTop: 15, color: '#000'}}>Travel Security</h2>
                                        <div className="form-group">
                                            <input type="hidden"
                                                   value=""
                                                   className="specialAdvisoryCountry"/>
                                            <legend>Notices and Advisories</legend>
                                            <label style={{marginBottom: 10, marginTop: 10}}>
                                                Select locations for which you want to receive Travel Security Notices
                                                and Advisories.
                                            </label>
                                            <div id="specialAdvisory"
                                                 className="bootstrap-tagsinput dropdown">
                                                <input type="text"
                                                       placeholder=""
                                                       size="1"
                                                       className="tagsinput"
                                                       data-toggle="dropdown"
                                                       readOnly="readonly"
                                                       style={{paddingLeft: 2}}/>
                                                <ul className="dropdown-menu countrysMenu">
                                                    <li>
                                                        <input type="text"
                                                               placeholder="You may enter initials to search country"
                                                               className="form-control inputRetrieval"/>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:" data-allcountry="all">All</a>
                                                    </li>
                                                    <li role="separator" className="divider"/>
                                                </ul>
                                            </div>
                                            <div id="travelNACheckBox" className="inline-group" data="text">
                                                <label className="checkbox"
                                                       style={{marginTop: 15, display: 'block', float: 'left'}}>
                                                    <input id="tn" type="checkbox" value="true"/>
                                                    <i/>
                                                    Notice
                                                </label>
                                                <label className="checkbox"
                                                       style={{marginTop: 15, display: 'block', float: 'left'}}>
                                                    <input id="ta" type="checkbox" value="true"/>
                                                    <i/>
                                                    Advisory
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <input type="hidden" value="" className="travelAlertCountry"/>
                                            <legend>Special Advisories and Evacuation Notifications</legend>
                                            <label style={{marginBottom: 10, marginTop: 10}}>
                                                Select locations for which you want to receive Travel Security Special
                                                Advisories and Evacuation Notifications.
                                            </label>
                                            <div id="travelAlert" className="bootstrap-tagsinput dropdown">
                                                <input type="text"
                                                       placeholder=""
                                                       size="1"
                                                       className="tagsinput"
                                                       data-toggle="dropdown"
                                                       readOnly="readonly"
                                                       style={{paddingLeft: 2}}/>
                                                <ul className="dropdown-menu countrysMenu">
                                                    <li>
                                                        <input type="text"
                                                               placeholder="You may enter initials to search country"
                                                               className="form-control inputRetrieval"/>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:" data-allcountry="all">All</a>
                                                    </li>
                                                    <li role="separator" className="divider"/>
                                                </ul>
                                            </div>
                                            <div id="travelCheckBox" className="inline-group" data="text">
                                                <label className="checkbox"
                                                       style={{marginTop: 15, display: 'block', float: 'left'}}>
                                                    <input id="tsa" type="checkbox" value="true"/>
                                                    <i/>
                                                    Special Advisory
                                                </label>
                                                <label className="checkbox"
                                                       style={{marginTop: 15, display: 'block', float: 'left'}}>
                                                    <input id="ten" type="checkbox" value="true"/>
                                                    <i/>
                                                    Evacuation Notification
                                                </label>
                                            </div>
                                        </div>
                                        <h2 style={{marginTop: 40, color: '#000'}}>Medical</h2>
                                        <div className="form-group">
                                            <input type="hidden" value="" className="medicalCountry"/>
                                            <legend>Notices, Advisories and Special Advisories</legend>
                                            <label style={{marginBottom: 10, marginTop: 10}}>Select locations for which
                                                you want to receive Medical Alerts.</label>
                                            <div id="medical" className="bootstrap-tagsinput dropdown">
                                                <input type="text"
                                                       placeholder=""
                                                       size="1"
                                                       className="tagsinput"
                                                       data-toggle="dropdown"
                                                       readOnly="readonly"
                                                       style={{paddingLeft: 2}}/>
                                                <ul className="dropdown-menu countrysMenu">
                                                    <li>
                                                        <input type="text"
                                                               placeholder="You may enter initials to search country"
                                                               className="form-control inputRetrieval"/>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:" data-allcountry="all">All</a>
                                                    </li>
                                                    <li role="separator" className="divider"/>
                                                </ul>
                                            </div>
                                            <div id="mediaCheckBox" className="inline-group" data="text">
                                                <label className="checkbox"
                                                       style={{marginTop: 15, display: 'block', float: 'left'}}>
                                                    <input id="mn" type="checkbox" value="true"/>
                                                    <i/>
                                                    Notice
                                                </label>
                                                <label className="checkbox"
                                                       style={{marginTop: 15, display: 'block', float: 'left'}}>
                                                    <input id="ma" type="checkbox" value="true"/>
                                                    <i/>
                                                    Advisory
                                                </label>
                                                <label className="checkbox"
                                                       style={{marginTop: 15, display: 'block', float: 'left'}}>
                                                    <input id="msa" type="checkbox" value="true"/>
                                                    <i/>
                                                    Special Advisory
                                                </label>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <footer className="text-center">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <a href="javascript:"
                                               className="btn btn-default"
                                               id="subscription"
                                               onClick={this.subscribeHandler}
                                               style={{
                                                   float: 'none',
                                                   color: subBtnFontColor || '#fff',
                                                   borderRadius: 5,
                                                   backgroundColor: subBtnBgColor
                                               }}>
                                                Save Preferences
                                            </a>&nbsp;
                                            <a href="javascript:"
                                               className="btn btn-default"
                                               id="unsubscribe"
                                               onClick={this.unSubscribeHandler}
                                               style={{
                                                   float: 'none',
                                                   color: unSubBtnFontColor || '#fff',
                                                   borderRadius: 5,
                                                   backgroundColor: unSubBtnBgColor
                                               }}>
                                                Unsubscribe
                                            </a>
                                        </div>
                                    </div>
                                </footer>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SubscribePage;


// WEBPACK FOOTER //
// ./src/container/subscribe/subscribePage.js